module.exports = __webpack_public_path__ + "static/media/industrial.c7d5bdb5.svg";